import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import * as React from 'react';
import { Suspense } from 'react';

const SubpageComponent = React.lazy(() => import('./SubpageComponent'));

export class SubpageNode extends DecoratorNode {
  __pageId;
  __title;
  __icon;

  static getType() {
    return 'subpage';
  }

  static clone(node) {
    return new SubpageNode(node.__pageId, node.__title, node.__icon, node.__key);
  }

  static importJSON(serializedNode) {
    const node = $createSubpageNode(serializedNode.pageId, serializedNode.title, serializedNode.icon);
    return node;
  }

  exportJSON() {
    return {
      pageId: this.__pageId,
      title: this.__title,
      icon: this.__icon,
      type: 'subpage',
      version: 1,
    };
  }

  constructor(pageId, title, icon, key) {
    super(key);
    this.__pageId = pageId;
    this.__title = title;
    this.__icon = icon;
  }

  createDOM(config) {
    const div = document.createElement('div');
    div.className = 'subpage-block-container';
    return div;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return (
      <Suspense fallback={null}>
        <SubpageComponent
          pageId={this.__pageId}
          title={this.__title}
          icon={this.__icon}
          nodeKey={this.getKey()}
        />
      </Suspense>
    );
  }
}

export function $createSubpageNode(pageId, title, icon) {
  return $applyNodeReplacement(new SubpageNode(pageId, title, icon));
}

export function $isSubpageNode(node) {
  return node instanceof SubpageNode;
}
